import {
  Article,
  ArticleApi,
  CommonHealthtoolInfo,
  CommonHealthtoolInfoApi,
  ContentSponsor,
  EmbeddedCommunityType,
  HealthtoolReviewer,
  ReviewedUserApi,
} from '.'

export enum Gender {
  Boy = 'boy',
  Girl = 'girl',
}

export enum BabyGrowthChartType {
  Weight,
  Height,
  Head,
  BMI,
}

export enum BabyGrowthChartDuration {
  Weekly,
  Monthly,
  Yearly,
}

export type BabyGrowthContentApi = {
  information: Array<{
    title: string
    description: string
  }>
  reviewed_by?: ReviewedUserApi
  reviewed_date: string
  meta_tag: string
  title: string
  description: string
  disclaimer: string
  is_sponsored: boolean
  sponsor: ContentSponsor
  featured_image: string
  is_leadgen: boolean
} & CommonHealthtoolInfoApi

export type BabyGrowthContent = {
  enable_ad: boolean
  information: Array<{
    title: string
    description: string
  }>
  reviewBy: HealthtoolReviewer
  metaTag: string
  title: string
  description: string
  disclaimer: string
  is_sponsored: boolean
  sponsor: ContentSponsor
  featuredImage: string
  isLeadgen: boolean
} & CommonHealthtoolInfo

export type ResultApi = {
  condition_risk_suggestion: string
  recommend_articles: Array<ArticleApi>
  faqs: Array<{ title: string; description: string }>
  seemore_link: string
}

export type Result = {
  conditionRiskSuggestion: string
  recommendArticles: Array<Article>
  faqs: Array<{ title: string; description: string }>
  seeMoreLink: string
}
export type ResultChartTypeApi =
  | 'girl_height'
  | 'girl_weight'
  | 'girl_head'
  | 'boy_height'
  | 'boy_weight'
  | 'boy_head'

export type ResultType = '3rd' | '15th' | '50th' | '85th' | '97th'

export type BabyGrowthResultApi = {
  [key in ResultChartTypeApi]: {
    [key in ResultType]?: ResultApi
  }
} & {
  enable_ad: boolean
  general_setting?: {
    community: EmbeddedCommunityType
    disclaimer?: string
  }
}

export type BabyGrowthResult = {
  [key in string]: {
    [key in string]?: Result
  }
} & {
  enable_ad?: boolean
  generalSetting?: {
    community?: EmbeddedCommunityType
    disclaimer?: string
  }
}
